import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'
export const WebhookBoletoList = (props) => <DefaultDataTable data={props} />
